import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { LoginComponent } from './login/login.component';
import { AuthService } from './services/auth.service';
import { AuthDataStorageService } from './services/auth-data-storage.service';
import { AuthGuard } from './guard/auth.guard';
import { LoggedInGuard } from './guard/logged.guard';
import { ForgottenPasswordComponent } from './forgotten-password/forgotten-password.component';
import { TotpComponent } from './totp/totp.component';
import { TotpGuard } from './guard/totp.guard';
import { ExternalSessionGuard } from './guard/external-session.guard';

@NgModule({
  imports: [CommonModule, BrowserModule, FormsModule, RouterModule],
  exports: [LoginComponent],
  providers: [AuthService, AuthDataStorageService, AuthGuard, LoggedInGuard, TotpGuard, ExternalSessionGuard],
  declarations: [LoginComponent, ForgottenPasswordComponent, TotpComponent],
})
export class AuthModule { }



// WEBPACK FOOTER //
// /home/runner/_work/monorepo/monorepo/admin-portal-old/src/app/auth/auth.module.ts